import { FC } from 'react';

import { PAGE_SIZES } from 'ui/paginationFooter';
import {
  useSearchParamState,
  serializationOptionsForNumberValue,
} from 'utils/hooks/useSearchParamState';

import { PAGE, PAGE_SIZE } from './constants';
import { PaginationContext, PaginationContextState } from './context';

export const PaginationContextProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const [pageSize, setPageSize] = useSearchParamState({
    searchParamKey: PAGE_SIZE,
    stateValueWhenSearchParamIsUnset: PAGE_SIZES[1],
    pushChangesToBrowserHistory: true,
    ...serializationOptionsForNumberValue,
  });
  const [currentPage, setCurrentPage] = useSearchParamState({
    searchParamKey: PAGE,
    stateValueWhenSearchParamIsUnset: 1,
    pushChangesToBrowserHistory: true,
    ...serializationOptionsForNumberValue,
  });

  const context: PaginationContextState = {
    pageSize,
    setPageSize,
    currentPage,
    setCurrentPage,
  };

  return <PaginationContext.Provider value={context}>{children}</PaginationContext.Provider>;
};
